import React from "react";
import { Button, Modal } from "@telia/teddy";
import CHECKOUT_TEXT from "../../../text-consts";
import "./EmptyCartModal.less";

interface EmptyCartModalProps {
    content?: string;
    onClose: () => void;
    onSubmit: () => void;
    title?: string;
}

const EmptyCartModal: React.FC<EmptyCartModalProps> = ({ title, content, onClose, onSubmit }) => {
    return (
        <Modal open onOpenChange={() => onClose()}>
            <Modal.Overlay className="emptyCartModal__overlay">
                <Modal.Content>
                    <Modal.Group variant="title">
                        <Modal.Title as="h3">{title}</Modal.Title>
                        <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                    </Modal.Group>
                    {content}
                    <Modal.Group variant="action">
                        <Modal.Close slot="content">
                            <Button variant="secondary" onClick={onClose}>
                                {CHECKOUT_TEXT.COMMON.CANCEL}
                            </Button>
                        </Modal.Close>
                        <Button variant="primary" onClick={onSubmit}>
                            {CHECKOUT_TEXT.COMMON.CONTINUE}
                        </Button>
                    </Modal.Group>
                </Modal.Content>
            </Modal.Overlay>
        </Modal>
    );
};

export default EmptyCartModal;
